// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const ChatFilled = (props: SVGProps<SVGSVGElement>) => (
	<svg width="1em" height="1em" viewBox="0 0 80 79" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			d="M20.5 47.8c-1.5-.4-3-.9-4.5-1.5-4.4 2.3-10.1 2.6-12.5 2.6H2.4c-.9 0-1.7-.7-1.9-1.6-.2-.9.3-1.8 1.1-2.2 0 0 3.4-1.8 5.3-5.1C2.8 35.6.5 30.1.5 24.4.5 11 13.1 0 28.5 0c10.9 0 20.9 5.6 25.4 14.2 1.7 3.2 2.6 6.7 2.6 10.2 0 .7 0 1.3-.1 2-1.6-.2-3.2-.3-4.9-.3-15 0-27.6 9.3-31 21.7Zm57.9 27.4s-3.4-1.8-5.3-5.1c4.2-4.4 6.4-9.9 6.4-15.6 0-13.5-12.6-24.4-28-24.4s-28 11-28 24.4C23.5 68 36.1 79 51.5 79c4.3 0 8.6-.9 12.5-2.6 4.5 2.4 10.2 2.6 12.5 2.6h1.1c.9 0 1.7-.7 1.8-1.6.1-.9-.1-1.8-1-2.2Z"
			fill="url(#ChatFilled_tsx__a)"
		/>
		<defs>
			<linearGradient
				id="ChatFilled_tsx__a"
				x1={57.369}
				y1={-21.765}
				x2={39.087}
				y2={78.838}
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#C4C4C4" stopOpacity={0.1} />
				<stop offset={1} stopColor="#C4C4C4" />
			</linearGradient>
		</defs>
	</svg>
);
export default ChatFilled;
